<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <WdsPageSignup class="wds-page-signup-login" nav-prev @prev="back">
    <template #left>
      <LeftWelcome />
    </template>

    <template #right>
      <WdsHeading as="h1" type="title1">
        {{ $t('Two-Factor authentication') }}
      </WdsHeading>

      <WdsText class="tw-mb-6" secondary>
        {{ $t(confirmationMessage) }}
      </WdsText>

      <WdsText v-show="state.codeSent" class="tw-mb-2">
        {{ $t("We've sent a new code to you. It should arrive shortly.") }}
      </WdsText>

      <BaseHtmlForm action="/mfa" method="POST" @submit="state.formSubmitted = true">
        <WdsInput
          v-model="state.input"
          name="code"
          placeholder="123 456"
          autocomplete="one-time-code"
          autofocus
          :error="state.errors.length === 0 ? null : state.errors.join('\n')"
          maxlength="6"
        >
          <template #label>
            <div class="tw-flex tw-justify-between tw-items-center">
              <span>{{ $t('Verification code') }}</span>
              <WdsButtonGhost v-if="shouldShowSendButton" type="button" secondary @click="sendCode">
                Send code via SMS
              </WdsButtonGhost>
            </div>
          </template>
        </WdsInput>
        <div class="tw-text-center tw-mt-6">
          <WdsButton primary full-width :disabled="disableSubmit">
            {{ $t('Verify code') }}
          </WdsButton>
        </div>
      </BaseHtmlForm>
    </template>
  </WdsPageSignup>
</template>

<script setup>
import {
  WdsButton,
  WdsButtonGhost,
  WdsHeading,
  WdsInput,
  WdsPageSignup,
  WdsText,
} from '@worksome/wds-components'
import { computed, reactive } from 'vue'
import axios from 'axios'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import LeftWelcome from '@/components/auth/left/LeftWelcome.vue'

const props = defineProps({
  errors: {
    type: Array,
    default: [],
  },
  channel: {
    type: String,
    required: true,
  },
})

const state = reactive({
  input: '',
  formSubmitted: false,
  codeSent: false,
  errors: props.errors,
})

const csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

const disableSubmit = computed(() => state.formSubmitted || state.input.length !== 6)

const shouldShowSendButton = computed(() => props.channel === 'sms' && !state.codeSent)

const messages = {
  sms: 'Enter the verification code sent to your phone by SMS',
  totp: 'Enter the verification code from your authentication app',
  default: 'Enter the verification code',
}

const confirmationMessage = messages[props.channel] || messages.default

const sendCode = () => {
  state.codeSent = true
  axios
    .post('/mfa-resend')
    .then(() => {
      setTimeout(() => {
        state.codeSent = false
      }, 60000)
    })
    .catch((e) => state.errors.push(e.response.data.message))
}

const back = () => {
  window.location.href = `${window.location.protocol}//${window.location.host}/logout`
}
</script>
